export const encodeParam = (param) => (param ? encodeURIComponent(param) : param);
